(() => {
  const initBrandDirectory = (root) => {
    if (!root || root.dataset.brandDirectoryInitialized === 'true') return;
    root.dataset.brandDirectoryInitialized = 'true';

    const input = root.querySelector('[data-brand-directory-input]');
    const items = Array.from(root.querySelectorAll('[data-brand-directory-item]'));
    const empty = root.querySelector('[data-brand-directory-empty]');
    const count = root.querySelector('[data-brand-directory-count]');

    if (!items.length) return;

    const singular = root.dataset.countSingular || 'varumarke';
    const plural = root.dataset.countPlural || 'varumarken';

    const update = () => {
      const query = (input?.value || '').trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const haystack = (item.dataset.search || '').toLowerCase();
        const matches = !query || haystack.includes(query);

        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (count) {
        count.textContent = `${visibleCount} ${visibleCount === 1 ? singular : plural}`;
      }

      if (empty) {
        empty.hidden = visibleCount > 0;
      }
    };

    if (input) {
      input.addEventListener('input', update);
      input.addEventListener('search', update);
    }

    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-brand-directory]').forEach((root) => initBrandDirectory(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
